<template>
    <div>
        <div v-if="desativedForm" >
            <formNotCss v-if="cssDisable" :data="publicData" :options="inputsOptions" :title="title"/>
            <div v-else class="express-form">
                <div class="express-form-header">
                    <h1 v-if="hasTitle">{{ title }}</h1>
                </div>
                <div class="express-form-body">
                    <div v-for="(item, index) in publicData" :key="index" class="show-inputs">
                        <ui-input 
                            v-if="item.type != 'textarea' && item.type != 'select'"
                            v-model="item.value"
                            :type="item.type" 
                            :label="item.label" 
                            :error="item.required" 
                            :observation="item.observation" 
                            :mask="item.mask"
                            :maskIntl="item.maskIntl"
							:maskIntlErrorDDI55="item.maskIntlErrorDDI55"
                            :label-color="labelColor"
                            :right-label="item.name == 'cpf' ? 'Porque exigimos CPF?' : !item.isRequired ? 'Opcional' : ''"
                            :placeholder="item.placeholder"
                            size="xxl" 
                            :tooltip = "item.name == 'cpf' ? { 
                                message:'Solicitamos seu CPF para autenticar o seu cadastro, prevenir fraudes e personalizar nosso atendimento. Seus dados serão mantidos em estrita confidencialidade.', 
                                width: '187px',
                                cursor: 'help'
                            } : {}"
                            background-color="#F8F9FB"
                            @input="checkcpf($event, item.name)"
                            @verify="checkError"
							@clearErrorDdi55="item.maskIntlErrorDDI55 = false"
                        />
                        
                        <ui-select-v2
                            v-if="item.type == 'select'"
                            v-model = "item.value" 
                            :label="item.label" 
                            :data="item.options"
                            :error="item.required" 
                            size="xxl"
                            :label-color="labelColor"
                            background-color="#F8F9FB"
                            :item-label="item.itemLabel"
                            :return-value="item.returnValue"
                            :right-label="!item.isRequired ? 'Opcional' : ''"
                            :observation="item.observation"
                        />

                        <ui-textarea
                            v-if="item.type == 'textarea'"
                            v-model = "item.value"
                            :label="item.label" 
                            :placeholder="item.placeholder"  
                            size="xxl"
                            :label-color="labelColor"
                            background-color="#F8F9FB"
                            :error="item.required"
                            :right-label="!item.isRequired ? 'Opcional' : ''"
                            :observation="item.observation" 
                        /> 
                    </div>
                
                </div>
                <div class="express-form-footer">
                    <div class="actions">
                        <p>Prometemos manter suas informações<br/>seguras e livres de spam.</p>
                        <ui-button :design="buttonColor ? 'xxl default' : 'xxl success'" :background="buttonColor" @click="sendForm" >{{ labelButton }}</ui-button>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="desatived">
            <div class="icone">
                <!-- <div class="triangle"></div> -->
                <em class="fas fa-exclamation-triangle"/>
            </div>
            <div class="message">
                Formulário desativado!
            </div>
        </div>
    </div>
</template>

<script>

import { uiButton } from '@/components/ui/buttons'
import { uiInput, uiTextarea, uiSelectV2 } from '@/components/ui/form'
import { apiPublic } from '@/services/axios'
import formNotCss from './form-not-css.vue'
import helpers from '@/mixins/helpers'


export default {
    name: 'ui-form',
    components: {
        uiInput,
        uiTextarea,
        uiButton,
        uiSelectV2,
        formNotCss
    },
    mixins: [ helpers ],
    props: {
        id: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            publicData: null,
            saved: false,
            stage: null,
            status: null,
            title: 'Captação de Leads',
            labelColor: null,
            buttonColor: null,
            labelButton: 'Enviar',
            hasTitle: null,
            cssDisable: null,
            hasError: false,
            desativedForm: false,
            inputsOptions: {}
        }
    },
    created() {
        const queryString = window.location.search

        const params = new URLSearchParams(queryString)

        this.buttonColor = params.get('cor_botao')
        this.labelButton = params.get('texto_botao') ? params.get('texto_botao') : 'Enviar'
        this.labelColor = params.get('cor_texto')
        this.hasTitle = params.get('ocultar_titulo') != ''
        this.cssDisable = !!params.has('css_disable')
        if(this.cssDisable) {
            this.inputsOptions = { 
                button: { 
                    background: this.buttonColor, 
                    label: this.labelButton 
                }, 
                inputs: {
                    color: this.labelColor
                },
                hasTitle: this.hasTitle,
                linkCss: params.get('css_link')
            }
        }

        apiPublic.getPublic('form/' + this.id).then(async res => {
            let status = res?.data?.data?.leads?.status
            this.desativedForm = status && status === "active"

            if(this.desativedForm) {
                this.publicData = await this.creatForm(res.data.data)
                this.title = res?.data?.data?.leads?.name ? res.data.data.leads.name : this.title
            }
            this.$emit('load', false)
        })
    },
    methods:{

        sendForm(){
            if(this.validRequisicion()) {
                this.$emit('load', true)
                const formData = new FormData()
                if(this.stage) formData.append(`deal[funnel_stage_id]`, this.stage)
                if(this.status) formData.append(`deal[funnel_stage_status_id]`, this.status)
                for (const key in this.publicData) {
                    const {name, value} = this.publicData[key]
                    switch(name) {
                        case 'products':
                            if(value) formData.append(`deal[product_id]`, value)
                            break
                        case 'message':
                            if(value) formData.append(`historical[message]`, value)
                            break
                        default: 
                            //  Separando o DDI do número para enviar
                            const fieldsMaskIntl = ['phone', 'mobile', 'phone_residential']
                            
                            if(fieldsMaskIntl.includes(name) && value){
                                if(value == '+55') break
                                let match = value.match(/^\+(\d{1,3})\s(.*)$/)

                                if(match){
                                    formData.append(`customer[country_code_${name}]`, match[1])
                                    formData.append(`customer[${name}]`, match[2])
                                    break
                                } 
                            }

                            if(value) formData.append(`customer[${name}]`, value)
                            break
                    }
                }

                apiPublic.createPublic('leads/execute/' + this.id, formData).then(result => {
                    let status = result.data.status
                    if(status == 'success') {
                        this.$emit('input', true)
                        return this.resetForm()
                    }
                    throw new Error('Algo deu errado')
                }).catch(error => {
                    this.$emit('input', false)
                    this.$emit('load', false)
                    this.$toastr.e(error)
                })

            }
        },
        /**
         * cria os dados para o formulário apartir de um array
         * @param {creatForm} data 
         */
        creatForm(data) {
            let field = data.field
            const fields = Object.keys(field).sort(compareKeys)
            /**
             * posiciona o array de acordo com a ordem definida no banco de dados
             */
            function compareKeys(a, b) {
                return field[a] - field[b]
            }

            this.stage = data.leads.funnel_stage_id
            this.status = data.leads.funnel_stage_status_id

            let newFileds = fields.map( res => {
                return {
                        value: this.setValue(res),
                        name: res,
                        type: this.setType(res),
                        options: this.setOptions(res, data),
                        label: this.setLabelAndPlaceholder(res, false) + ':',
                        required: false,
                        observation: '',
                        placeholder: this.setLabelAndPlaceholder(res, true),
                        mask: this.setMask(res),
                        maskIntl: this.setMaskIntl(res),
						maskIntlErrorDDI55: false,
                        itemLabel: res == 'products' ? 'name' : res == 'state' ? 'estado' : 'value',
                        returnValue: res == 'products' ? 'id' : res == 'state' ? 'uf' : 'value',
                        isRequired: this.isRequired(res, data)
                }
            })
            /**
             * passa o input message sempre para o ultimo do array
             * 
             */
            const indexMessage = newFileds.findIndex(obj => obj.name == 'message')
            const objMessage = newFileds.splice(indexMessage, 1)[0]
            newFileds.push(objMessage)
            
            /**
             * mantem o input tipo name como primeiro
             */

            const indexName = newFileds.findIndex(obj => obj.name === 'name');
            const objName = newFileds.splice(indexName, 1)[0];
            newFileds.unshift(objName);

            return newFileds
        },
        setOptions(name, data) {
            switch (name) {
                case 'products':
                    return data.products
                case 'state_civil':
                    return [
                        { value: 'Não informado' },
                        { value: 'Solteiro(a)' },
                        { value: 'Casado(a)' },
                        { value: 'Divorciado(a)' },
                        { value: 'Viúvo(a)' },
                    ]
                case 'state':
                    return data.uf
                case 'income':
                    return [
                        { value: "Até R$ 2.500" },
                        { value: "De R$ 2.500 à R$ 5.000" },
                        { value: "De R$ 5.000 à R$ 7.500" },
                        { value: "De R$ 7.500 à R$ 10.000" },
                        { value: "De R$ 10.000 à R$ 20.000" },
                        { value: "Acima de R$ 20.000" },
                    ]
            }
        },
        /**
         * verifica e seleciona os campos obrigatórios
         * @param {name object} name 
         * @param {data in requision api} data 
         */
        isRequired(name, data) {
            if(name == 'products') return data.fieldsRequired.includes('deal_product_id')
            if(data.fieldsRequired) return data.fieldsRequired.includes(name)
            return false
        },
        /**
         * seta o tipo do input
         */
        setType(name) {
            return ['products','state_civil','state','income'].includes(name) ? 'select' : 
            ['phone', 'mobile', 'phone_resindetial'].includes(name) ? 'tell' : 
            name == 'cpf' ? 'cpf' : 
            name == 'email' ? 'email' : 
            name == "message" ? 'textarea' : 
            name == "children" ? 'number':
            'text'
        },
        /**
         * valida os campos e verifica se algum campo obrigatório esta vazio
         */
        validRequisicion() {
            
            this.publicData.forEach( val => {
				const isPhoneNumber = ["mobile", "phone", "phone_resindetial"].includes(val.name);

                if(val.isRequired == true && (val.value == '' || val.value == null)) {
                    if(["name", "email", "phone", "mobile", "cpf", "phone_resindetial", "address", "complement", "state"].includes(val.name)) {
                        val.observation = 'Por favor, informe o seu ' + val.label.toLowerCase()
                    }
                    else if(["products", "profession", "state_civil", "profession", "city"].includes(val.name)) {
                        val.observation = 'Por favor, selecione um(a) ' + val.label.toLowerCase()
                    }
                    else if(["message", "business", "income"].includes(val.name)) {
                        val.observation = 'Por favor, informe a sua ' + val.label.toLowerCase()
                    }
                    else {
                        val.observation = 'Por favor, informe uma quantidade de ' + val.label.toLowerCase()
                    }
                    
                    val.required = true
                }
				else if(isPhoneNumber && val.isRequired == true && val.value == '+55'){
					val.observation = 'Por favor, informe o seu ' + val.label.toLowerCase()
					val.maskIntlErrorDDI55 = true
					val.required = true
				}
                else {
                    val.observation = ''
                    val.required = false
                    if(val.name == 'cpf') {
                        this.checkcpf(val.value)
                    }
                }
            })
            let hasRequired = this.publicData.find(val => val.required == true)
            if(this.hasError) hasRequired = true
            return !hasRequired ? true : false
        },
        /**
         *  seta o tipo de mascara para todo tipo de input
         * @param {number} name 
         */
        setMask(name) {
            const maskTypes = { 
                cpf: '###.###.###-##' 
            }

            return maskTypes[name] || '';
        },
        /**
         *  seta o tipo de mascara internacional os inputs de telefone
         */
        setMaskIntl(name) { 
            const maskTypes = { 
                mobile: "mobile", 
                phone: "phone", 
                phone_residential: "phone_residential" 
            }; 

            return maskTypes[name] || ''; 
        },
        /**
         *  seta o valor padrão de DDI +55 para números de telefone
         */
        setValue(name) {
           const maskTypes = ["mobile", "phone", "phone_residential"];

           return maskTypes.includes(name) ? '55' : '';
        },
        setLabelAndPlaceholder( name, placeholder ) {
            switch (name) {
                case "email":
                    return placeholder ? 'Digite seu melhor e-mail' : 'E-mail'
                case "phone":
                    return placeholder ? 'Acessível em horário comercial' : 'Telefone'
                case "mobile":
                    return placeholder ? 'Informe o Whatsapp': "Celular"
                case "message":
                    return placeholder ? 'Como podemos te ajudar?' : "Mensagem"
                case "business":
                    return placeholder ? 'Sua Empresa' : 'Empresa'
                case "address":
                    return placeholder ? 'Seu endereço' : 'Endereço'
                case "complement":
                    return placeholder ? 'Seu complemento': 'Complemento'
                case "city":
                    return placeholder ? 'Informe a cidade onde mora': 'Cidade'
                case "name":
                    return placeholder ? 'Digite seu nome completo' : 'Nome'
                case "products":
                    return "Empreendimento"
                case "children":
                    return 'Quantidade de Filhos'
                case "phone_resindetial":
                    return 'Telefone Residencial'
                case "profession":
                    return 'Profissão'
                case "income":
                    return 'Renda Familiar'
                case "state_civil":
                    return 'Estado Civil'
                case "state":
                    return 'Estado'
                case "cpf":
                    return 'CPF'
            }
        },
        /**
         * limpa o formulário
         */
        resetForm() {
            for (const key in this.publicData) {
                this.publicData[key].value = null
            }
        },
        /**
         * valida o cpf
         * @param {cpf} value 
         */
        checkcpf(value, name) {
            if(value?.length >= 14 && name == 'cpf') {
                let confereCpf =  this.validateCpf(value)
                if(!confereCpf) {
                    this.publicData.map( val => {
                        if(val.name == 'cpf') {
                            val.required = true
                            val.observation = 'Por favor, informe um CPF válido'
                        }
                    })
                }
                else {
                    this.publicData.map( val => {
                        if(val.name == 'cpf') {
                            val.required = false
                            val.observation = ''
                        }
                    })
                }
               
            }
        },
        checkError(value) {
            this.hasError = !value
        }
    },
}
</script>

<style lang="stylus" scoped>
    @import './styles.styl'
</style>